import React from 'react';
import Navbar from '../navbar/Navbar';
import Header from '../header/Header';
import Cards from '../cards/Cards';
import Footer from '../footer/Footer';

const Main = () => {
  return (
    <div className='main'>
      <Navbar />
      <Header />
      <Cards />
      <Footer />
    </div>
  );
};

export default Main;
